<template>
  <div
    class="flex flex-col flex-1 bg-[radial-gradient(ellipse_at_bottom,_oklch(1_0_0),_oklch(0.5184_0.184_261.62_/_0.1))] dark:bg-none"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { useAppearanceClass } from '@/domains/admin-panel/composables/use-appearance/useAppearance'

// The sign-in pages follow the browser's saved theme too, before anyone signs in (DEC-2026-060).
useAppearanceClass()
</script>
